import { useRef } from 'react';
import {
  useEventCallback,
  AbortableFetch,
  abortableFetch,
} from '@eas/common-web';
import { EvidenceAPI } from '../../../enums';

/**
 * Api call
 *
 * @param id
 */
function callApi(id: string) {
  return abortableFetch(`${EvidenceAPI.NOTIFICATION_RECEIVED}/${id}/read`, {
    method: 'PUT',
  });
}

export function useRead({ refresh }: { refresh: () => void }) {
  /**
   * Fetch ref.
   */
  const fetch = useRef<AbortableFetch | null>(null);

  const handleRead = useEventCallback(async (id: string) => {
    try {
      if (fetch.current !== null) {
        fetch.current.abort();
      }

      fetch.current = callApi(id);

      await fetch.current.raw();

      refresh();
    } catch (err) {
      if (err.name !== 'AbortError') {
        throw err;
      }
      return undefined;
    }
  });

  return { handleRead };
}
